<mat-expansion-panel
  class="flotante-panel"
  [expanded]="expansionPanelExpanded"
  (expandedChange)="expansionPanelExpanded = $event"
>
  <mat-expansion-panel-header>
    <mat-panel-title>
      <mat-icon class="material-symbols-outlined">tune</mat-icon>
      <span class="panel-title">Luminarias</span>
      <span class="counter-badge">
        {{ luminariasFiltradas.length }}
        @if (luminariasFiltradas.length !== (luminariasLength ?? 0)) {
          / {{ luminariasLength ?? 0 }}
        }
      </span>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <!-- BUSCADOR + BOTÓN FILTROS -->
  <div class="seccion top-bar">
    <div class="buscador-wrapper">
      <mat-icon class="search-icon material-symbols-outlined">search</mat-icon>
      <input
        type="text"
        class="buscador-input"
        placeholder="Buscar..."
        [(ngModel)]="textoBusqueda"
        (ngModelChange)="onBusquedaChange()"
      />
      @if (textoBusqueda) {
        <button
          irxBotonIcono
          tamano="mini"
          class="clear-btn"
          (click)="limpiarBusqueda()"
          tooltip="Limpiar búsqueda"
        >
          <mat-icon class="material-symbols-outlined">close</mat-icon>
        </button>
      }
    </div>

    <button
      irxBotonIcono="borde"
      tamano="compacto"
      class="btn-filtros"
      [activo]="hayFiltrosModalActivos"
      (click)="abrirDialogFiltros()"
      tooltip="Abrir filtros"
    >
      <mat-icon class="material-symbols-outlined">filter_alt</mat-icon>
      @if (hayFiltrosModalActivos) {
        <span class="filter-badge"></span>
      }
    </button>

    @if (hayBusquedaOFiltrosModal) {
      <button
        irxBotonIcono="borde"
        tamano="compacto"
        class="btn-filtros btn-reset"
        (click)="limpiarSoloFiltros()"
        tooltip="Limpiar filtros"
      >
        <mat-icon class="material-symbols-outlined">filter_alt_off</mat-icon>
      </button>
    }
  </div>

  <!-- ACCIONES DE POLÍGONO -->
  <div class="seccion">
    <button
      irxBoton="secundario"
      tamano="compacto"
      bloque
      class="btn-poligono"
      [matMenuTriggerFor]="menuPoligono"
      tooltip="Dibujá un polígono y elegí qué hacer con las luminarias dentro de él"
    >
      <mat-icon class="material-symbols-outlined">draw</mat-icon>
      <span>Acciones de polígono</span>
      <mat-icon class="material-symbols-outlined chevron">expand_more</mat-icon>
    </button>

    <mat-menu #menuPoligono="matMenu" class="menu-poligono">
      @for (accion of accionesPoligono; track accion.key) {
        <button
          mat-menu-item
          class="item-poligono"
          (click)="accionPoligono.emit(accion.key)"
          [attr.aria-label]="accion.tooltip"
        >
          <mat-icon class="material-symbols-outlined">
            {{ accion.icono }}
          </mat-icon>
          <span>{{ accion.label }}</span>
        </button>
      }
    </mat-menu>
  </div>

  <!-- CAPAS -->
  <div class="seccion">
    <div class="seccion-titulo">Capas</div>
    <!-- Píldoras de capas -->
    <div class="poligonos-pills">
      <!-- Mostrar: clusters + gateways -->
      <div class="pill-item">
        <irx-segmentado class="visibility-toggle-group" tamano="compacto">
          <irx-segmento
            (click)="onToggleCluster()"
            [activo]="clusterEnabled"
            tooltip="Mostrar/Ocultar clusters"
          >
            <mat-icon class="material-symbols-outlined">
              {{ clusterEnabled ? 'blur_on' : 'blur_off' }}
            </mat-icon>
          </irx-segmento>

          <irx-segmento
            (click)="onToggleGateway()"
            [activo]="gatewayEnabled"
            tooltip="Mostrar/Ocultar gateways"
          >
            <mat-icon class="material-symbols-outlined">
              {{ gatewayEnabled ? 'podcasts' : 'podcasts' }}
            </mat-icon>
          </irx-segmento>
        </irx-segmentado>
        <span class="pill-label">Mostrar</span>
      </div>

      <!-- Polígonos clientes -->
      <div class="pill-item">
        <irx-segmentado class="visibility-toggle-group" tamano="compacto">
          <irx-segmento
            (click)="onTogglePoligonoClientes()"
            [activo]="poligonoClientesEnabled"
            tooltip="Mostrar/Ocultar polígonos de clientes"
          >
            <mat-icon class="material-symbols-outlined">
              {{ poligonoClientesEnabled ? 'layers' : 'layers_clear' }}
            </mat-icon>
          </irx-segmento>

          <irx-segmento
            (click)="onToggleTextoClientes()"
            [disabled]="!poligonoClientesEnabled"
            [tooltip]="
              textoClientesEnabled
                ? 'Ocultar nombres de clientes'
                : 'Mostrar nombres de clientes'
            "
          >
            <mat-icon>
              {{ textoClientesEnabled ? 'match_case' : 'match_case_off' }}
            </mat-icon>
          </irx-segmento>
        </irx-segmentado>
        <span class="pill-label">Clientes</span>
      </div>

      <!-- Polígonos zonas -->
      <div class="pill-item">
        <irx-segmentado class="visibility-toggle-group" tamano="compacto">
          <irx-segmento
            (click)="onTogglePoligonoZonas()"
            [activo]="poligonoZonasEnabled"
            tooltip="Mostrar/Ocultar polígonos de zonas"
          >
            <mat-icon class="material-symbols-outlined">
              {{ poligonoZonasEnabled ? 'hexagon' : 'pentagon' }}
            </mat-icon>
          </irx-segmento>

          <irx-segmento
            (click)="onToggleTextoZonas()"
            [disabled]="!poligonoZonasEnabled"
            [tooltip]="
              textoZonasEnabled
                ? 'Ocultar nombres de zonas'
                : 'Mostrar nombres de zonas'
            "
          >
            <mat-icon>
              {{ textoZonasEnabled ? 'match_case' : 'match_case_off' }}
            </mat-icon>
          </irx-segmento>
        </irx-segmentado>
        <span class="pill-label">Zonas</span>
      </div>
    </div>
  </div>

  <!-- ESTADOS -->
  @if (estados?.length) {
    <div class="seccion">
      <div class="seccion-titulo seccion-titulo-row">
        <span>Estados</span>
        @if (hayEstadosFiltrados) {
          <button
            irxBotonIcono
            tamano="mini"
            class="btn-reset-inline"
            (click)="limpiarSoloEstados()"
            tooltip="Restaurar todos los estados"
          >
            <mat-icon class="material-symbols-outlined">refresh</mat-icon>
          </button>
        }
      </div>
      <!-- Dona del resumen (la pone el mapa) a la izquierda de los chips -->
      <div class="estados-con-dona" [class.sin-dona]="!dona">
        @if (dona) {
          <ng-container [ngTemplateOutlet]="dona"></ng-container>
        }
        <div class="estados-grid">
          @for (estado of estados; track estado.nombre) {
            <button
              type="button"
              class="irx-chip irx-chip--multilinea capa-chip estado-chip"
              [attr.aria-pressed]="filtrosEstado.includes(estado.nombre)"
              (click)="toggleEstado(estado.nombre)"
              [tooltip]="estado.nombre"
            >
              <span class="estado-icon-bg">
                <img
                  [src]="estado.icono"
                  [alt]="estado.nombre"
                  class="estado-icon"
                />
              </span>
              <span class="capa-label">{{ estado.nombre }}</span>
              <span class="capa-count">{{ estado.cant }}</span>
            </button>
          }
        </div>
      </div>
    </div>
  }

  <!-- Las que no tienen ubicación real no se dibujan ni entran en los
       conteos (como en FARO): sólo se avisa cuántas son. -->
  @if (sinUbicacion > 0) {
    <div
      class="sin-ubicacion"
      [tooltip]="
        sinUbicacion === 1
          ? 'No se dibuja ni se cuenta: no tiene ubicación cargada'
          : 'No se dibujan ni se cuentan: no tienen ubicación cargada'
      "
    >
      <mat-icon class="material-symbols-outlined">location_off</mat-icon>
      {{ sinUbicacion | number }} sin ubicación
    </div>
  }

  @if (hayFiltrosActivos) {
    <button
      irxBoton="secundario"
      type="button"
      class="limpiar-btn"
      (click)="limpiarFiltros()"
    >
      <mat-icon class="material-symbols-outlined">filter_alt_off</mat-icon>
      Limpiar todo
    </button>
  }
</mat-expansion-panel>
